<div class="layout">
    <div [id]="'chart-container'+id" [style]="'width:100%;height:'+(height=='100%'?'350px':height)"></div>
</div>